import { Card, CardHeader, CardTitle, CardDescription } from "@tellescope/ui";
import type { CardBlock as CardBlockType } from "../../../shared/schema";

interface CardBlockProps {
  title?: CardBlockType["props"]["title"];
  description?: CardBlockType["props"]["description"];
}

export const CardBlock: React.FC<CardBlockProps> = ({ title, description }) => {
  // Don't render empty cards
  if (!title && !description) return null;

  return (
    <Card>
      <CardHeader>
        {title && <CardTitle>{title}</CardTitle>}
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
    </Card>
  );
};
